module.exports = __webpack_public_path__ + "assets/bac31b87983a6e64636b8b374d4eeb20.svg";